import { request } from '../utils/request';
import { v4 as uuid } from 'uuid';
import { getDocumentLinkPath, formatSources } from '../utils/sourcesHelper';
import { cleanCitations } from '../utils/textHelper';

const DATABAS_CLIENT_URL = import.meta.env.VITE_DATABAS_CLIENT_URL;

const sendQuestion = async (question) => {
	const response = await request({
		method: 'POST',
		url: '/ai/rag/send',
		data: {
			message: question,
		},
	});

	if (response.status === 200) {
		// Form real links for the sources
		const formattedSources = formatSources(response.sources);

		return {
			timestamp: new Date(),
			question,
			answer: cleanCitations(response.message),
			sources: formattedSources,
			conversationId: response.conversationId,
			followUpEnabled: response.followUpEnabled ? true : false,
		};
	}

	try {
		const responseError = JSON.parse(response.error);
		return {
			id: null,
			timestamp: 0,
			question,
			answer: '',
			sources: [],
			error: {
				code: responseError.error.code,
				message: responseError.error.message,
			},
		};
	} catch (error) {
		console.error(error);
	}
};

const sendFollowUpQuestion = async (question, conversationId) => {
	const response = await request({
		method: 'POST',
		url: '/ai/rag/send/followup',
		data: {
			message: question,
			conversationId,
		},
	});

	if (response.status === 200) {
		// Form real links for the sources
		const formattedSources = formatSources(response.sources);

		return {
			id: uuid(),
			timestamp: new Date(),
			question,
			answer: cleanCitations(response.message),
			sources: formattedSources,
			conversationId: response.conversationId,
			followUpEnabled: response.followUpEnabled ? true : false,
			aiModelReference: response.aiModelReference,
			elasticDocuments: response.elasticDocuments,
		};
	}

	try {
		const responseError = JSON.parse(response.error);
		return {
			id: null,
			timestamp: 0,
			question,
			answer: '',
			sources: [],
			error: {
				code: responseError.error.code,
				message: responseError.error.message,
			},
		};
	} catch (error) {
		console.error(error);
	}
};

const getQuota = async (token) => {
	const response = await request({
		method: 'GET',
		url: '/ai/rag/quota',
		token,
	});

	return response;
};

export { sendQuestion, sendFollowUpQuestion, getQuota };
